var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.$t('organisations.access.labels.title'),"items":_vm.items,"item-text":"name","item-value":"value","rules":_vm.rules},model:{value:(_vm.access),callback:function ($$v) {_vm.access=$$v},expression:"access"}})}
var staticRenderFns = []

export { render, staticRenderFns }